// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comparison-workspace {
  position: relative;
  height: calc(100vh - 56px);
  min-height: 760px;
  overflow: hidden;
  background:
    linear-gradient(180deg, rgba(15, 23, 42, 0.04), rgba(15, 23, 42, 0.1)),
    #dbe4ee;
}

.comparison-top-left-rail {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 1300;
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.comparison-top-left-rail .map-load-indicator {
  margin-top: 1px;
}

.comparison-workspace.is-shared-open .comparison-top-left-rail {
  z-index: 1100;
  pointer-events: none;
}

.comparison-shared-backdrop {
  position: absolute;
  inset: 0;
  z-index: 1150;
  background: rgba(15, 23, 42, 0.32);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.comparison-shared-backdrop.is-open {
  opacity: 1;
  pointer-events: auto;
}

.comparison-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100%;
  gap: 0;
}

.comparison-grid-single {
  grid-template-columns: minmax(0, 1fr);
}

.comparison-panel {
  position: relative;
  min-width: 0;
  border-right: 1px solid rgba(15, 23, 42, 0.18);
  background: #cfd8e3;
  z-index: 1000;
}

.comparison-panel:last-child {
  border-right: none;
}

.comparison-panel-left.is-raised {
  z-index: 1200;
}

.comparison-panel-single.is-raised {
  z-index: 1200;
}

.comparison-frame {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
  background: #dbe4ee;
}

@media (max-width: 1100px) {
  .comparison-workspace {
    height: auto;
    min-height: calc(100vh - 56px);
    overflow: auto;
  }

  .comparison-grid {
    grid-template-columns: 1fr;
    min-height: calc(100vh - 56px);
  }

  .comparison-panel {
    min-height: 70vh;
    border-right: none;
    border-bottom: 1px solid rgba(15, 23, 42, 0.18);
  }

  .comparison-panel:last-child {
    border-bottom: none;
  }

  .comparison-top-left-rail {
    flex-wrap: wrap;
  }

}
`, "",{"version":3,"sources":["webpack://./src/styles/personal/comparison_maps.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB;;WAES;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;EAC9C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,8BAA8B;IAC9B,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,+CAA+C;EACjD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":[".comparison-workspace {\n  position: relative;\n  height: calc(100vh - 56px);\n  min-height: 760px;\n  overflow: hidden;\n  background:\n    linear-gradient(180deg, rgba(15, 23, 42, 0.04), rgba(15, 23, 42, 0.1)),\n    #dbe4ee;\n}\n\n.comparison-top-left-rail {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  z-index: 1300;\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n}\n\n.comparison-top-left-rail .map-load-indicator {\n  margin-top: 1px;\n}\n\n.comparison-workspace.is-shared-open .comparison-top-left-rail {\n  z-index: 1100;\n  pointer-events: none;\n}\n\n.comparison-shared-backdrop {\n  position: absolute;\n  inset: 0;\n  z-index: 1150;\n  background: rgba(15, 23, 42, 0.32);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n}\n\n.comparison-shared-backdrop.is-open {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.comparison-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  height: 100%;\n  gap: 0;\n}\n\n.comparison-grid-single {\n  grid-template-columns: minmax(0, 1fr);\n}\n\n.comparison-panel {\n  position: relative;\n  min-width: 0;\n  border-right: 1px solid rgba(15, 23, 42, 0.18);\n  background: #cfd8e3;\n  z-index: 1000;\n}\n\n.comparison-panel:last-child {\n  border-right: none;\n}\n\n.comparison-panel-left.is-raised {\n  z-index: 1200;\n}\n\n.comparison-panel-single.is-raised {\n  z-index: 1200;\n}\n\n.comparison-frame {\n  width: 100%;\n  height: 100%;\n  border: none;\n  display: block;\n  background: #dbe4ee;\n}\n\n@media (max-width: 1100px) {\n  .comparison-workspace {\n    height: auto;\n    min-height: calc(100vh - 56px);\n    overflow: auto;\n  }\n\n  .comparison-grid {\n    grid-template-columns: 1fr;\n    min-height: calc(100vh - 56px);\n  }\n\n  .comparison-panel {\n    min-height: 70vh;\n    border-right: none;\n    border-bottom: 1px solid rgba(15, 23, 42, 0.18);\n  }\n\n  .comparison-panel:last-child {\n    border-bottom: none;\n  }\n\n  .comparison-top-left-rail {\n    flex-wrap: wrap;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
